import { createContext, useState, useEffect } from 'react';
import { createContextualCan } from '@casl/react';
import { defineAbilitiesFor } from './ability';

export const AbilityContext = createContext();
export const Can = createContextualCan(AbilityContext.Consumer);

export const AbilityProvider = ({ children }) => {
  const [ability, setAbility] = useState(() => {
    const storedUser = sessionStorage.getItem('userDetails');
    const user = storedUser ? JSON.parse(storedUser) : {};
    console.log("user", user);
    return defineAbilitiesFor(user);
  });

  useEffect(() => {
    const updateAbility = () => {
      const storedUser = sessionStorage.getItem('userDetails');
      const user = storedUser ? JSON.parse(storedUser) : {};
      setAbility(defineAbilitiesFor(user));
    };

    // Listen for storage events (works across tabs)
    window.addEventListener('storage', updateAbility);

    // Listen for custom event (for same-tab updates)
    window.addEventListener('userChanged', updateAbility);

    return () => {
      window.removeEventListener('storage', updateAbility);
      window.removeEventListener('userChanged', updateAbility);
    };
  }, []);

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
};